// Tim's portraits, keyed by the mood the reaction engine already reports.
//
// Legacy naming: the assets live under /magnum/ on purpose — see CLAUDE.md
// "Legacy Naming (do not rename)". The art itself is Tim.
//
// All five share one crop box, so they swap in place inside a speech bubble
// without the head shifting. Keep that true of any replacement art.
import type { Mood } from '@/context/MagnumContext'

/** Moods the engine can report, plus the landing-page gag. */
export type TimPose = Mood | 'withering'

const ART: Record<TimPose, string> = {
  neutral: '/magnum/tim-neutral.webp',
  happy: '/magnum/tim-happy.webp',
  encouraging: '/magnum/tim-encouraging.webp',
  excited: '/magnum/tim-excited.webp',
  withering: '/magnum/tim-withering.webp',
}

export function timArt(pose: TimPose | null | undefined): string {
  return ART[pose ?? 'neutral'] ?? ART.neutral
}

/**
 * Full-bleed art for the screen-time launch — Tim mid-transformation, opening
 * the stream. Deliberately a different register from the portraits above:
 * painterly, full body, wrapped in effects. Backgrounds are left in, because
 * the magic and the ruins are the drama and no cutout survives separating a
 * glow from what it is glowing against.
 */
const LAUNCH_ART = [
  '/magnum/launch/tim-launch-1.webp',
  '/magnum/launch/tim-launch-2.webp',
  '/magnum/launch/tim-launch-3.webp',
  '/magnum/launch/tim-launch-4.webp',
  '/magnum/launch/tim-launch-5.webp',
  '/magnum/launch/tim-launch-6.webp',
]

export function randomLaunchArt(): string {
  return LAUNCH_ART[Math.floor(Math.random() * LAUNCH_ART.length)]
}

/**
 * Warm the cache for the poses a session will swap between, so the first
 * correct answer doesn't flash an empty bubble while the image loads.
 */
export function preloadTimArt(): void {
  for (const src of Object.values(ART)) {
    const img = new Image()
    img.src = src
  }
}
